import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { AdvisoryModel } from '../data';
import { AdvisoryModelApiRepository } from '../repositories/advisory-model-api.repository';
import { AdvisoryModelCacheRepository } from '../repositories/advisory-model-cache.repository';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class AdvisoryModelProvider {
    constructor(
        private advisoryModelApiRepository: AdvisoryModelApiRepository,
        private advisoryModelCacheRepository: AdvisoryModelCacheRepository
    ) {}

    find(): Observable<Transaction<AdvisoryModel[]>> {
        return concat(
            this.advisoryModelCacheRepository.load(),
            this.advisoryModelApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.advisoryModelCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
